<div style="min-height: 100vh; background: #f5f7fb; color: #1f2937;">
  <section style="background: linear-gradient(135deg, #522710, #f37430);color: #fff;padding: 3rem 1.5rem;">
    <div class="main-content">
      <div class="main-text">
        <!-- <div class="main-label">{{ OwnerName }}</div> -->
        <div class="main-label" style="text-transform: capitalize;">{{ senderCompanyAddrese?.senderCompanyName ?? "AliceTms" }}</div>
        <h1>{{'TRACKANDTRACEPAGE.TRACKSHIPMENT' | translate}}</h1>
        <p> {{'TRACKANDTRACEPAGE.TRACKINGTEXT' | translate}} </p>

      </div>

      <div class="main-card">
        <div style="font-size: 0.9rem; color: #6b7280; margin-bottom: 0.5rem;">{{'TRACKANDTRACEPAGE.TRACKINGNUMBER' | translate}}</div>
        <div *ngIf="!IsloggedIn; else input" style="font-size: 1.4rem; font-weight: 700; word-break: break-word;">{{ trackingNumber }}</div>
        <ng-template #input>
          <input pInputText style="color: black;" [(ngModel)]="trackingNumber">
          <button pButton (click)="FindShipment()">{{"TRACKANDTRACEPAGE.FINDEVENTS" |translate}}</button>
        </ng-template>

        <div *ngIf="getLatestScan()" style="margin-top: 1rem;">
          <span class="status-icon" [ngClass]="getStatusClass()">
            {{ getStatusText() }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <section class="content-section">
    <div *ngIf="loading" class="info-box">
      {{'TRACKANDTRACEPAGE.LOADINGTRACKING' | translate}}
    </div>

    <div *ngIf="errorMessage" class="info-box error">
      {{ errorMessage }}
    </div>

    <ng-container *ngIf="!loading && !errorMessage">
      <!-- Headers -->
      <div class="TrackAndTrace-grid">
        <div class="TrackAndTrace-card">
          <div class="TrackAndTrace-title">{{'TRACKANDTRACEPAGE.WAYBILL' | translate}}</div>
          <div class="TrackAndTrace-value">{{ wayBill || '-' }}</div>
        </div>

        <div class="TrackAndTrace-card">
          <div class="TrackAndTrace-title">{{'TRACKANDTRACEPAGE.LASTUPDATE' |translate}}</div>
          <div class="TrackAndTrace-value">
            {{ (getLatestScan()?.scanDateTime | date:'dd-MM-yyyy HH:mm') || '-'}}
          </div>
        </div>

        <div class="TrackAndTrace-card">
          <div class="TrackAndTrace-title">{{'TRACKANDTRACEPAGE.TRACKINGTERMINAL' | translate}}</div>
          <div class="TrackAndTrace-value">
            {{ getLatestScan()?.terminal || '-' }}
          </div>
        </div>

        <div class="TrackAndTrace-card">
          <div class="TrackAndTrace-title">ETA</div>
          <div class="TrackAndTrace-value">
            {{(Eta | date:'dd-MM-yyyy HH:mm') || '-' }}
          </div>
        </div>
      </div>

      <!-- Sender -->
      <div class="sender-card" *ngIf="senderCompanyAddrese">
        <div style="font-size: 0.85rem; color: #6b7280; text-transform: capitalize; margin-bottom: 0.5rem;"> {{"TRACKANDTRACEPAGE.SENDER" |translate}}</div>
        <div style="font-weight: 700; margin-bottom: 0.25rem;">
          <!-- senderShipment?.senderCompanyName = "" while   senderCompanyAddrese?.senderCompanyName ?? "" = Local Dev Environment-->
          {{ SenderShipment?.senderCompanyName ?? "" ||  senderCompanyAddrese?.senderCompanyName ?? ""}}
        </div>
        <!-- <div>{{ senderCompanyAddrese.street || senderCompanyAddrese.Street }}</div>
        <div>{{ senderCompanyAddrese.zipcode || senderCompanyAddrese.Zipcode }}</div> -->
      </div>

      <!-- Preview -->
      <div class="preview-box" *ngIf="PictureToShow">
        <div class="preview-box-header">
          <span>Preview</span>
          <button type="button" class="preview-close" (click)="clearPreview()"> X </button>
        </div>
        <img [src]="PictureToShow" alt="Shipment image preview" />
      </div>

      <!-- histrory  *ngIf="scans && scans.length > 0" -->
      <div class="histrory-wrapper" *ngIf="scans.length > 0">
        <div class="histrory-title">{{"TRACKANDTRACEPAGE.SHIPMENTHISTRORY" |translate}}</div>

        <div class="histrory-item" *ngFor="let scan of scans; let last = last">
          <div class="histrory-left">
            <div class="histrory-marker">
              <i [class]="getScanIcon(scan)"></i>
            </div>
            <div class="histrory-line" *ngIf="!last"></div>
          </div>

          <div class="histrory-content">
            <div class="histrory-top">
              <div class="histrory-text">
                {{ scan.text || scan.text || 'Shipment update' }}
              </div>

              <div class="histrory-actions">
                <i
                   class="pi pi-camera image-btn"
                   *ngIf="scan.image"
                   (click)="Showpicture(scan)">
                </i>

                <i
                   class="pi pi-file image-btn"
                   *ngIf="scan.file"
                   (click)="Showfile(scan)">
                </i>
              </div>
            </div>

            <div style="margin-top: 0.4rem; color: #6b7280; font-size: 0.92rem; display: flex; gap: 0.5rem; flex-wrap: wrap;">
              <span *ngIf="scan.scanDateTime">
                {{ (scan.scanDateTime) | date:'dd-MM-yyyy HH:mm' }}
              </span>

              <span *ngIf="scan.cause">
                • {{ scan.cause }}
              </span>

              <span>
                • {{ scan.terminal}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="info-box" *ngIf="scans && scans.length === 0">
        {{"TRACKANDTRACEPAGE.TRACKNGEVENTNOTFOUND" | translate}}
        No tracking events found.
      </div>
    </ng-container>
  </section>
</div>